
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/viagens/lua-de-mel",
      function () {
        return require("private-next-pages/viagens/lua-de-mel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/viagens/lua-de-mel"])
      });
    }
  